const ProductDetail = [
  {
    id: 1,
    productName: "iPhone 15",
    productImg: "./img/mobile/iPhone (1).png",
    productCat: "Phones",
    productPrice: "98000",
  },
  {
    id: 2,
    productName: "Samsung S23 Ultra",
    productImg: "./img/mobile/samS23.jpg",
    productCat: "Phones",
    productPrice: "75000",
  },
  {
    id: 3,
    productName: "OnePus Nord 2E",
    productImg: "./img/mobile/onePlus.png",
    productCat: "Phones",
    productPrice: "33000",
  },
  {
    id: 4,
    productName: "Samsung M34s 5G",
    productImg: "./img/mobile/samM34.jpg",
    productCat: "Phones",
    productPrice: "24000",
  },
  {
    id: 5,
    productName: "Xiomi Power",
    productImg: "./img/XiPB.png",
    productCat: "Powerbank",
    productPrice: "24000",
  },
  {
    id: 6,
    productName: "Tablet",
    productImg: "./img/Tablet.png",
    productCat: "Tabs",
    productPrice: "27000",
  },
  {
    id: 7,
    productName: "Apple Watch Series 3",
    productImg: "./img/appleWatch2.png",
    productCat: "Smartwatch",
    productPrice: "24000",
  },
  {
    id: 8,
    productName: "Samsung Gear S3",
    productImg: "./img/samG3.png",
    productCat: "Smartwatch",
    productPrice: "14000",
  },
  {
    id: 9,
    productName: "Samsung Gear S3",
    productImg: "./img/samG3.png",
    productCat: "Smartwatch",
    productPrice: "14000",
  },
  {
    id: 10,
    productName: "Samsung Gear S3",
    productImg: "./img/samG3.png",
    productCat: "Smartwatch",
    productPrice: "14000",
  },
  {
    id: 11,
    productName: "Samsung Gear S3",
    productImg: "./img/samG3.png",
    productCat: "Smartwatch",
    productPrice: "14000",
  },
  {
    id: 12,
    productName: "Samsung Gear S3",
    productImg: "./img/samG3.png",
    productCat: "Smartwatch",
    productPrice: "14000",
  },
];

export default ProductDetail;
